import { lighten, shade } from 'polished'

export default {
  wholesalers: {
    primary: '#3D41D7',
    gradient: 'linear-gradient(90deg, #3D41D7 0%, #3D8DD7 100%)',

    gradientDarken: `linear-gradient(90deg, ${shade(0.05, '#3D41D7')}, ${shade(
      0.05,
      '#3D8DD7'
    )})`,

    gradientLighten: `linear-gradient(90deg, ${lighten(
      0.05,
      '#3D41D7'
    )}, ${lighten(0.05, '#3D8DD7')})`
  },

  dispatchers: {
    primary: '#C31A4C',
    danger: '#ff4100',
    gradient: 'linear-gradient(90deg, #C31A4C, #f50b50)',
    gradientDarken: `linear-gradient(90deg, ${shade(0.05, '#C31A4C')}, ${shade(
      0.05,
      '#f50b50'
    )})`,

    gradientLighten: `linear-gradient(90deg, ${lighten(
      0.05,
      '#C31A4C'
    )}, ${lighten(0.05, '#f50b50')})`
  },

  finances: {
    primary: '#04a781',
    gradient: 'linear-gradient(90deg ,#019289, #04a781)',
    gradientDarken: `linear-gradient(90deg, ${shade(0.05, '#019289')}, ${shade(0.05, '#04a781')})`,
    gradientLighten: `linear-gradient(90deg, ${lighten(0.05, '#019289')}, ${lighten(0.05, '#04a781')})`
  },

  default: {
    background: '#fff',
    foreground: '#F3F6FF',
    border: '1px solid #f9f9f9',
    input: '#FAFAFA',

    white: '#fff',
    black: '#000',
    gray: '#606369',
    gray_1: '#F2F2F2',
    gray_2: '#E1E1E1',
    gray_3: '#B5B5B5',
    gray_4: '#505050',
    gray_5: '#252525',

    text: '#606369',
    heading: '#000',

    primary: '#001d3d',
    info: '#37474f',
    danger: '#ed0000',
    warning: '#ff3d00',
    success: '#18c600',
    dangerLighten: '#ff4242',
    warningLighten: '#ff6838',
    successLighten: '#27AE60',
    gradient: 'linear-gradient(90deg, #001d3d, #003566)',

    gradientDarken: `linear-gradient(90deg, ${shade(0.05, '#001d3d')}, ${shade(
      0.05,
      '#003566'
    )})`,

    gradientLighten: `linear-gradient(90deg, ${lighten(
      0.05,
      '#001d3d'
    )}, ${lighten(0.05, '#003566')})`,

    pagguePurple: '#7C009F',
    paggueGreen: '#16EF96',
    paggueBlue: '#11DCF7',

    screens: {
      sm: 'min-width: 640px',
      md: 'min-width: 768px',
      lg: 'min-width: 1024px',
      xl: 'min-width: 1280px',
      xxl: 'min-width: 1536px',
      // max_xs: 'max-width: 420px',
      // max_sm: 'max-width: 639px',
      max_md: 'max-width: 767px'
      // max_lg: 'max-width: 1023px',
      // max_xl: 'max-width: 1279px',
      // max_xxl: 'max-width: 1536px'
    }
  }
}
